import { render, staticRenderFns } from "./InsolvencyEscalationFile.vue?vue&type=template&id=753133a6&scoped=true&"
import script from "./InsolvencyEscalationFile.vue?vue&type=script&lang=js&"
export * from "./InsolvencyEscalationFile.vue?vue&type=script&lang=js&"
import style0 from "./InsolvencyEscalationFile.vue?vue&type=style&index=0&id=753133a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "753133a6",
  null
  
)

export default component.exports